import { ActionMenu } from "@impero-com/ui";
import { useParams } from "react-router-dom";

import type { UserProfile } from "api/generated/model";

import { useAssignmentCountQuery } from "./queries/useAssignmentCountQuery";
import { useUserWithDetailsQuery } from "./queries/useUserWithDetailsQuery";
import { canDeleteUser, useUserActions } from "./userActions";
import { UserDetails } from "./UserDetails";
import { UserViewPage } from "./UserViewPage";

interface UserDetailsPageProps {
    orgProfileCookie: UserProfile | null;
}

export function UserDetailsPage({ orgProfileCookie }: UserDetailsPageProps) {
    const { id: userId } = useParams();

    if (!userId) {
        throw new Error("User ID parameter is missing in route");
    }

    const { data: assignmentCount } = useAssignmentCountQuery(userId);
    const { data: userWithDetails } = useUserWithDetailsQuery(Number(userId));
    const { actions, dialog } = useUserActions(
        userWithDetails,
        canDeleteUser(assignmentCount)
    );

    return (
        <UserViewPage
            actions={<ActionMenu id={actions.id} actions={actions.actions} />}
        >
            {dialog}
            <UserDetails orgProfileCookie={orgProfileCookie} />
        </UserViewPage>
    );
}
